export const partnerQueryKeys = {
  all: ["partner"],
  me: () => [...partnerQueryKeys.all, "me"],
  dashboard: () => [...partnerQueryKeys.all, "dashboard"],
  clients: (params) => [...partnerQueryKeys.all, "clients", params],
  client: (id) => [...partnerQueryKeys.all, "client", id],
  courses: (params) => [...partnerQueryKeys.all, "courses", params],
  applications: (clientId) => [...partnerQueryKeys.all, "applications", clientId],
  applicationHistory: (clientId, module, entryId) => [
    ...partnerQueryKeys.all,
    "application-history",
    clientId,
    module,
    entryId,
  ],
  applicationRequests: (params) => [...partnerQueryKeys.all, "application-requests", params],
  leads: (params) => [...partnerQueryKeys.all, "leads", params],
  lead: (id) => [...partnerQueryKeys.all, "lead", id],
  leadForm: (id) => [...partnerQueryKeys.all, "lead-form", id],
  documentRequests: (params) => [...partnerQueryKeys.all, "document-requests", params],
  documentRequest: (id) => [...partnerQueryKeys.all, "document-request", id],
  commissions: (params) => [...partnerQueryKeys.all, "commissions", params],
  payouts: (params) => [...partnerQueryKeys.all, "payouts", params],
  messages: (params) => [...partnerQueryKeys.all, "messages", params],
  tasks: (params) => [...partnerQueryKeys.all, "tasks", params],
  task: (id) => [...partnerQueryKeys.all, "task", id],
  notifications: (params) => [...partnerQueryKeys.all, "notifications", params],
  notificationCount: () => [...partnerQueryKeys.all, "notification-count"],
  appointments: (params) => [...partnerQueryKeys.all, "appointments", params],
  appointmentStaff: () => [...partnerQueryKeys.all, "appointment-staff"],
  terms: () => [...partnerQueryKeys.all, "terms"],
  enrolment: () => [...partnerQueryKeys.all, "enrolment"],
  offers: () => [...partnerQueryKeys.all, "offers"],
  offer: (id) => [...partnerQueryKeys.all, "offer", id],
  allOffers: (page) => [...partnerQueryKeys.all, "offers", "all", page],
  faqs: () => [...partnerQueryKeys.all, "faqs"],
  support: () => [...partnerQueryKeys.all, "support"],
  supportList: (status) => [...partnerQueryKeys.support(), "list", status],
  supportUnread: () => [...partnerQueryKeys.support(), "unread"],
};
